import React, { useState } from "react";
import {
  addFavoritesMobileIcon,
  cancelIcon,
  rebookIcon,
} from "../../assets/images";
import CustomButton from "../../common/Buttons/CustomButton";
import {
  IFavRecords,
  ITripDetails,
} from "../ServiceUsers/Interfaces/ITripDetails";
import { Row, Col } from "antd";
import { useTripActions } from "../../hooks/useTripActions";
import DashboardFavoriteModal from "../DashBoard/DashboardFavoriteModal";
import CancelTripModal from "./CancelTripModal";
import { usePaginationCtx } from "../../context/PaginationContext";
import {
  SUProfileRebookMessage,
  dashboardRebookMessage,
} from "../../types/TripTypes";
import { useLocation } from "react-router-dom";
import { TrackAnalytics } from "../../types/ApplicationTypes";

type Props = {
  allTripLegs: ITripDetails[];
  selectedLeg: ITripDetails;
};
const TripActionButtons: React.FC<Props> = ({ allTripLegs, selectedLeg }) => {
  const [isFavModalVisible, setIsFavModalVisible] = useState<boolean>(false);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState<boolean>(
    false
  );
  const [favRecords, setFavRecords] = useState<IFavRecords>();

  const { rebookTrip } = useTripActions();
  const { activeTabCtx } = usePaginationCtx();
  const [activeTab] = activeTabCtx;
  const { pathname } = useLocation();

  const handleAddToFavorites = () => {
    const data = {
      selectedLeg: [selectedLeg],
      allLegs: allTripLegs.length ? allTripLegs : [selectedLeg],
      legsCount: allTripLegs.length || [selectedLeg].length,
    };
    setFavRecords(data);
    setIsFavModalVisible(true);
  };

  const handleRebookTrip = () => {
    const isDashboardPage = pathname
      .split("/")
      .some((pathSegment) => pathSegment === "ProfileMobilePage");
    if (isDashboardPage) {
      const event = dashboardRebookMessage[activeTab];
      TrackAnalytics("/DashBoard", event, "DashBoard Mobile Page");
    } else {
      const event = SUProfileRebookMessage[activeTab];
      TrackAnalytics(
        "/DashBoard/ManageServiceUsers",
        event,
        "ManageServiceUsers Mobile Page"
      );
    }
    rebookTrip({ selectedLeg: selectedLeg, allLegs: allTripLegs });
  };

  const handleCancelTrip = () => setIsCancelModalVisible(true);

  const favoriteBtn = (
    <Col>
      <CustomButton
        type="default"
        icon={addFavoritesMobileIcon}
        text="Add to Favorites"
        className="tripActionBtn"
        handlerFunction={handleAddToFavorites}
      />
    </Col>
  );

  const rebookBtn = (
    <Col>
      <CustomButton
        type="default"
        icon={rebookIcon}
        text="Rebook Service"
        handlerFunction={handleRebookTrip}
        className="tripActionBtn"
      />
    </Col>
  );

  const cancelBtn = (
    <Col>
      <CustomButton
        type="default"
        icon={cancelIcon}
        text="Cancel Service"
        handlerFunction={handleCancelTrip}
        className="tripActionBtn"
      />
    </Col>
  );

  return (
    <>
      {["Completed", "Cancelled"].includes(selectedLeg?.statusDetail) ? (
        <Row justify="center" gutter={[15, 15]}>
          {favoriteBtn}
          {rebookBtn}
        </Row>
      ) : (
        <Row justify="center" gutter={[15, 15]}>
          {rebookBtn}
          {cancelBtn}
        </Row>
      )}

      <CancelTripModal
        trip={selectedLeg}
        isCancelModalVisible={isCancelModalVisible}
        setIsCancelModalVisible={setIsCancelModalVisible}
      />

      <DashboardFavoriteModal
        favModalVisible={isFavModalVisible}
        favRecords={favRecords}
        setFavModalVisible={setIsFavModalVisible}
        isDesktop
      />
    </>
  );
};

export default TripActionButtons;
